import React from 'react';

// FeatureGrid block — optional <h2> + a grid of {title, text} cards. Presentation only. Active and
// available for authoring; unused by the Phase-1 default service content.
export default function FeatureGrid({ heading, items }) {
  return (
    <section className="mb-10">
      {heading ? (
        <h2 className="mb-6 font-heading text-2xl font-bold text-black">{heading}</h2>
      ) : null}
      <ul className="grid gap-4 sm:grid-cols-2">
        {items.map((it, i) => (
          <li key={i} className="rounded-xl border border-neutral-200 bg-white p-5">
            <h3 className="mb-1 font-semibold text-black">{it.title}</h3>
            <p className="text-sm text-neutral-600">{it.text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
